import { render } from "./TextEditorGroup.vue?vue&type=template&id=85e56160"
import script from "./TextEditorGroup.vue?vue&type=script&lang=js"
export * from "./TextEditorGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__